import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";

// Updated custom hook paths
import moment from "moment";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../components/Layout";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

import Actions from "../../components/Common/Actions";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import PharmacyRatingCount from "../../components/Modal/PharmacyRatingCount";
import SucessModal from "../../components/Modal/SucessModal";

const PharmacyRatingForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const addNewPharmacyPartnerID = {
    id: "addnewpost",
    onClick: () => navigate(`/rp-qr-ratings/add-new-pharmacy-partner-id`),
    style: { width: "240px" },
    label: "Add New Pharmacy Partner ID",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Modal states
  const [countModal, setCountModal] = useState({ id: "", status: false });
  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}rating-form/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "rating-form",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    (!assignModal.status && !leadStatusModal.status) && setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search,assignModal.status,leadStatusModal.status]);

  const columns = [
    {
      title: "S.No",
      key: "index",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      fixed: "left",
      width: 80,
    },
    {
      title: "Pharmacy Partner ID",
      dataIndex: "pharmacy_id",
      key: "pharmacy_id",
      width: 220,
      render: (id) => (
        <span
          onClick={() => setCountModal({ id, status: true })}
          className="cursorPointer"
        >
          {id}
        </span>
      ),
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 200,
    },
    {
      title: "Mobile No",
      dataIndex: "mobile",
      key: "mobile",
      fixed: "left",
      width: 200,
    },
    {
      title: "Time of Registration",
      dataIndex: "createdAt",
      key: "time",
      width: 220,
      render: (createdAt) => moment(createdAt).format("LT"),
    },
    {
      title: "Date of Registration",
      dataIndex: "createdAt",
      key: "date",
      width: 220,
      render: (createdAt) => moment(createdAt).format("DD-MM-YYYY"),
    },
    {
      title: "Was all your required prescribed medicine available?",
      dataIndex: "prescribed_medicine",
      key: "prescribed_medicine",
      width: 250,
    },
    {
      title: "Was all your required OTC's/Healthcare products available?",
      dataIndex: "products_available",
      key: "products_available",
      width: 250,
    },
    {
      title:
        "Are you satisfied with the discount % provided for prescribed medicine",
      dataIndex: "satisfy_with_discount",
      key: "satisfy_with_discount",
      width: 250,
    },
    {
      title:
        "Does the pharmacy owner / manager explain the advantages of InstaDoc",
      dataIndex: "explain_adv",
      key: "explain_adv",
      width: 190,
    },
    {
      title:
        "Will you come back to buy your prescribed medicine in my pharmacy",
      dataIndex: "come_back",
      key: "come_back",
      width: 220,
    },
    {
      title: "Will you refer / suggest my pharmacy to others?",
      dataIndex: "refer",
      key: "refer",
      width: 220,
    },
    {
      title: "Rate your overall experience",
      dataIndex: "rating",
      key: "rating",
      width: 250,
    },
    {
      title: "Feedback",
      dataIndex: "feedback",
      key: "feedback",
      width: 200,
    },
    {
      title: "Share your concerns and suggestions through an image",
      dataIndex: "images",
      key: "images",
      width: 230,
      render: (images) =>
        images?.length
          ? images.map((img, index) => (
              <img
                key={index}
                // src={getsrcValue(img)}
                alt="feedback"
                style={{ width: 50, height: 50, margin: "5px" }}
              />
            ))
          : "-",
    },
    {
      title: "App Download Android Click",
      dataIndex: "android_click",
      width: 200,
      key: "android_click",
      render: (val) => val || "-",
    },
    {
      title: "App Download iOS Click",
      dataIndex: "ios_click",
      key: "ios_click",
      render: (val) => val || "-",
      width: 220,
    },
    {
      title: "Brochure Icon Click Status (1.0)",
      dataIndex: "brochure_click",
      key: "brochure_click",
      width: 320,
      render: (val) => val || "-",
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      key: "assigned_to",
      render: (val) => val || "-",
      width: 200,
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      key: "lead_status",
      render: (val) => val || "-",
      width: 200,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isAssignedTo={true}
          isDelete={true}
          isLeadStatus={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickLeadStatus={() =>
            setLeadStatusModal({ id: record._id, status: true })
          }
          onClickAssignedTo={() =>
            setAssignModal({ id: record._id, status: true })
          }
        />
      ),
    },
  ];

  const dataSource = records.map((record) => ({ ...record, key: record._id }));

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    fetchData();
  };

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          breadcrumbsList={[
            { text: "RP QR ratings", link: "/rp-qr-ratings/pharmacy-rating" },
            { text: "QR Ratings Submission", link: "" },
          ]}
        />
      }
      addButton={<FilledButton props={addNewPharmacyPartnerID} />}
      titles={<></>}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable medicineList_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      {assignModal.status && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
        />
      )}

      {leadStatusModal.status && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          page={location.pathname}
          post="Assigned"
          onClick={() => successModalClose()}
        />
      )}

      {countModal.status && (
        <PharmacyRatingCount
          id={countModal?.id}
          setCountModal={setCountModal}
        />
      )}

      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={() => successModalClose()}
          page={location.pathname}
        />
      )}
    </ListPageLayout>
  );
};

export default PharmacyRatingForm;
